import React, {Component} from "react"
import Report from "../../components/report/Report"
import Header from "./report/Header"
import {connect} from "react-redux"
import {injectIntl} from "react-intl"
import {getUserScheduleById, queryCountries, queryEducations, queryUserInfoById} from "../../dispatch"
import formatDuration from "format-duration"
import {
  COGO_TRAINING_NO_OF_CYCLES_PER_SESSION,
  COLOR_ATTENTIVE,
  COLOR_DISENGAGED,
  COLOR_IMPUSIVE, COLOR_NAVY, DATE_DISPLAY_FORMAT, DATETIME_FORMAT,
  getGender
} from "../../constants"
import {convertToDisplayFormat} from "../../util/DateUtil"
import CogolandOverallProgressChart from "../enterprise/dashboard/components/CogolandOverallProgressChart"
import SvgRect from "../../components/report/SvgRect"
import SvgText from "../../components/report/SvgText"


const DATE_FORMAT = 'll'
const DATE_FORMAT_TABLE = 'l(ddd)'

function mapStateToProps(state, ownProps) {
  const user = state.user
  const schedule = state.schedule
  const selectedUser = state.selectedUser
  return {
    user, schedule, selectedUser
  }
}

const mapDispatchToProps = {
  queryUserInfoById,
  getUserScheduleById,
  queryEducations,
  queryCountries

}

class EnterpriseCogolandUserReportView extends Component {

  constructor(data) {
    super(data)
    console.log(data)
    this.state = {
      userId: data.params.id,
      index: data.location.query['index'] || 1,
    }

  }

  componentWillMount() {
    const userId = this.state.userId
    this.props.queryUserInfoById(userId)
    this.props.getUserScheduleById(userId)
  }

  render() {


    const intl = this.props.intl
    const format = intl.formatMessage

    const header = (<div className="m-b-sm">
      <Header text={format({id: "cogoland.report.title"})}/>
    </div>)

    const user = this.props.selectedUser || {}
    const schedule = this.props.schedule || {}
    const sessions = _.sortBy((schedule.sessions || []), 'index')
    const cycleList = _.chunk(sessions, COGO_TRAINING_NO_OF_CYCLES_PER_SESSION)

    const reportIndex = _.toNumber(this.state.index)

    const cycle1Index = cycleList.length > 1?Math.min(reportIndex, cycleList.length - 1):1
    const cycle2Index = cycleList.length > 1?cycle1Index + 1:undefined

    const cycle1 = cycleList[cycle1Index - 1]
    const cycle2 = cycle2Index?cycleList[cycle2Index - 1]:[]

    const firstSession = _.first(sessions) || {}
    const lastSession = _.last(sessions) || {}

    const country = user.country ? format({id: 'country.' + user.country}) : '-'


    const userInfo = (
      <div className="row m-t-xs report-p">

        <div className="col-xs-6">
          <div>{format({id:"name"})}: {user.name}</div>
          <div>{format({id:"email"})}: {user.emailAddress}</div>
          <div>{format({id:"age"})}: {user.age}</div>
          <div>{format({id:"location"})}: {country}</div>
        </div>
        <div className="col-xs-6">

          <div>{format({id: 'start.date'})}: {_.toUpper(convertToDisplayFormat(firstSession.dateTimeUnlock, DATE_FORMAT))}</div>
        </div>

      </div>
    )

    const generateSessionTrList = list=>{
      return list.map(session => {
        const activities = _.sortBy(session.activities, 'index')
        const formatScore = (n) => n? _.round(n) : ''
        const gameActivities = activities.filter(it=>_.startsWith(it.type.name, 'GAME'))

        const averageAttentionList = gameActivities.map(it=>it.averageAttention).filter(it=>!_.isNil(it))
        const longestAttentionSpanList = gameActivities.map(it=>it.longestAttentionSpan).filter(it=>!_.isNil(it)).map(it=>{

          if(_.isString(it)){
            let split = it.split(":")
            const min = split[0]
            const sec = split[1]
            const result = _.toNumber(min)*60+sec
            return result
          }else return it
        })
        const averageAttention = averageAttentionList.length>0?_.sum(averageAttentionList)/averageAttentionList.length:0
        const engagementCountList =  gameActivities.map(it=>it.engagementCount).filter(it=>!_.isNil(it))
        const longestAttentionSpan = _.max(longestAttentionSpanList)

        return (
          <tr>
            <td className="text-center">{session.index}</td>
            <td className="text-center">{session.dateTimeCompleted ? _.toUpper(convertToDisplayFormat(session.dateTimeCompleted, DATE_FORMAT)) : '-'}</td>
            <td className="text-center">{formatScore(gameActivities[0].averageAttention)}</td>
            <td className="text-center">{formatScore(gameActivities.length > 1?gameActivities[1].averageAttention:undefined)}</td>
            <td className="text-center">{longestAttentionSpan?formatDuration(longestAttentionSpan*1000, {leading: true}):""}</td>
          </tr>
        )
      })
    }

    const renderSessionsTable = (list)=> (
        <table width="100%" className="table table-bordered report-table">
          <thead>
          <tr className={'font-noraml'}>
            <th className={'text-center'}>{format({id: 'cogoland.session.index'})}</th>
            <th className={'text-center'} style={{width:120}}>{format({id: 'cogoland.session.completed.date'})}</th>
            <th className={'text-center'} style={{width:100}}>{format({id: 'cogoland.session.game1.average.attention'}) + " (%)"}</th>
            <th className={'text-center'} style={{width:100}}>{format({id: 'cogoland.session.game2.average.attention'}) + " (%)"}</th>
            <th className={'text-center'}>{format({id: 'longest.attention.span.achieved'}) + " (mm:ss)"}</th>
          </tr>
          </thead>
          <tbody>
          {generateSessionTrList(list)}
          </tbody>
        </table>
    )

    const cycleIndexList = [cycle1Index, cycle2Index]
    const sessionsToRender = _.concat(cycle1, cycle2)

    const attentionPerformanceList = (<div className="">
      <div className={"report-p"}>{format({id: 'cogoland.report.table.desc'})}</div>

      <div className="row">
        {cycle1?[_.take(sessionsToRender, sessionsToRender.length / 2), _.takeRight(sessionsToRender, sessionsToRender.length / 2)].map((list, index) => (
          <div className={'col-xs-6'}>
            <SvgText weight="bold" color={COLOR_NAVY} text={cycleIndexList[index]?`${format({id:"cycle"})} ${cycleIndexList[index]}`:""}/>
            {renderSessionsTable(list)}
          </div>
        )):''}
      </div>

      <div>
        <SvgText width={400} height={70}
          weight="bold"
          color={COLOR_NAVY}
          text={format({id:"longest.attention.span.achieved"})}/>
        <div className={'report-p'}>{format({id:"longest.attention.span.achieved.desc"})}</div>
      </div>
    </div>)
    const attentionPerformanceChart = cycle1?<CogolandOverallProgressChart forReport={true} cycle1Sessions={cycle1} cycle2Sessions={cycle2} cycle1Index={cycle1Index} cycle2Index={cycle2Index}/>:''

    const insights = (<div className="col-xs-12 m-t-sm">
      <SvgText width={400} height={80}
               weight="bold"
               color={COLOR_NAVY}
               text={format({id:"cogoland.report.insights.title"})}/>
      {[
        {name: 'basic'},
        {name:'intermediate'},
        {name:'advanced'}
      ].map(it => {
        return (<div className={"m-t-sm"}>
          <div className={"report-p"}><b>{format({id:`cogoland.report.insights.${it.name}.title`})}</b>: {format({id:`cogoland.report.insights.${it.name}.desc`})}</div>
        </div>)
      })}
    </div>)

    const disclaimer = (<div className={"col-xs-12"} style={{marginTop: 900}}>
      <div className={"report-disclaimer font-bold"}>{format({id:`disclaimer`})}</div>
      <div className={"report-disclaimer-p"}>{format({id:`cogo.report.disclaimer`})}</div>
    </div>)

    return (
      <Report width={280}>
        {header}
        {userInfo}
        {attentionPerformanceList}
        {attentionPerformanceChart}
        <div className={'print-page-bottom'}>
          {insights}
          {disclaimer}
        </div>
      </Report>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(EnterpriseCogolandUserReportView))



// WEBPACK FOOTER //
// ./src/routes/cogoland/EnterpriseCogolandUserReportView.js